var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.246145,
    y: 0.663246,
    width: 13.206,
    height: 13.3021,
    transform: "matrix(0.908751 0.417338 -0.416462 0.909153 7.3895 -0.0424718)",
    fill: "#FED3B5",
    stroke: "#4B4A50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.18896,
    width: 15.1344,
    height: 19.4369,
    fill: "white",
    stroke: "#4B4A50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45376 22.0334C5.87318 22.034 5.30777 21.8513 4.84082 21.5122V24.7391L6.45426 23.7639L8.0677 24.7391V21.5122C7.60051 21.8515 7.03469 22.0343 6.45376 22.0334Z",
    fill: "white",
    stroke: "#4B4A50",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45371 22.0505C7.93884 22.0505 9.14278 20.8466 9.14278 19.3614C9.14278 17.8763 7.93884 16.6724 6.45371 16.6724C4.96858 16.6724 3.76465 17.8763 3.76465 19.3614C3.76465 20.8466 4.96858 22.0505 6.45371 22.0505Z",
    fill: "#FF9D5A",
    stroke: "#4B4A50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 6.9917,
    width: 10.2184,
    height: 1.07563,
    rx: 0.537813,
    fill: "#4B4A50"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 9.68066,
    width: 10.2184,
    height: 1.07563,
    rx: 0.537813,
    fill: "#4B4A50"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 12.3696,
    width: 5.91594,
    height: 1.07563,
    rx: 0.537813,
    fill: "#4B4A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits3);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-3.7bb64c91b7d9b0f575130de14ea2b7b6.svg";
export { ForwardRef as ReactComponent };